import { useEffect, useRef, useState, memo, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainLoading from "../../Components/Loading/MainLoading";
import { getMoreInfo, getOverlay } from "../../Redux/MoreInfo/moreInfoSlice";
import { getRandomItem } from "../../utils/utils";
import Categories from "./Components/PlutoCategories";
import PlutoFeatured from "./Components/PlutoFeatured";
import PlutoLeftSidebar from "./Components/PlutoLeftSidebar";
import "animate.css";
import { getShowsByCategory } from "../homepage/service";
import { useLocation, useParams } from "react-router-dom";
import { getHomeData } from "../../Redux/HomeData/homeDataSlice";
import { getEventMoreInfo } from "../../Redux/MoreInfo/eventMoreInfoSlice";
// import EventDetailsScreenModal from "../EventDetailsScreenModal/EventDetailsScreenModal";
import useScrollPosition from "../../Components/ScrollPosition/useScrollPosition";
import { useNavigate } from "react-router-dom/dist";

const PlutoHomePage = memo(() => {

  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const homeCollection = useSelector((state) => state?.homeData?.value);
  const isMoreInfo = useSelector((state) => state?.moreInfo?.value);
  const isEventMoreInfo = useSelector((state) => state?.eventMoreInfo?.value);
  const isMoreInfoOther = useSelector((state) => state?.moreInfoOther?.value);
  const user = useSelector((state) => state?.user?.value);
  const userDetails = useSelector((state) => state?.userDetails?.value);

  const [featured, setFeatured] = useState()
  const [loading, setLoading] = useState(true);
  const [homeData, setHomeData] = useState([]);
  const [homeDataSliceCount, setHomeDataSliceCount] = useState(8);
  const [thumbnailOrientation, setThumbnailOrientation] = useState("");
  const [activeCategory, setActiveCategory] = useState(null);
  const [isManualScrolling, setIsManualScrolling] = useState(false);
  const dispatch = useDispatch()
  const location = useLocation()
  const homePageContainerRef = useRef(null);
  const categoryRefs = useRef({});
  const scrollPosition = useScrollPosition();

  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };

  const navigate = useNavigate()

  useEffect(() => {

    if (projectInfo?.projectConfig?.config?.MULTI_LANGUAGE_REQUIRED === "true") {

      if (userDetails?.language_id === null || !userDetails?.language_id || userDetails?.language_id === "") {
        navigate("/language-selection")
        localStorage.setItem("redirectURL", "/home")
      }
    }
  }, [userDetails])

  useEffect(() => {
    setLoading(true);
    fetchShowDetails();
  }, [user]);

  useEffect(() => {

    if (!loading && homeDataSliceCount < homeData?.length) {
      lazyLoad()
    }
  }, [loading, scrollPosition, homeData])

  useEffect(() => {

    if (homeCollection?.length > 0) {
      setHomeData(homeCollection)
    }
  }, [homeCollection])

  useEffect(() => {

    if (projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION === "PORTRAIT") {
      setThumbnailOrientation("PORTRAIT");
    } else {
      setThumbnailOrientation("LANDSCAPE");
    }
  }, [projectInfo]);

  useEffect(() => {

    if (location?.pathname) {
      let id = location?.pathname.split("/")[2];
      let path = location?.pathname.split("/")[1];

      if (id !== "null" && id !== "undefined" && id && path === "show-details") {
        dispatch(
          getMoreInfo({
            moreInfo: true,
          })
        )
      }
      else if (id !== "null" && id !== "undefined" && id && path === "event") {
        dispatch(
          getEventMoreInfo({
            eventMoreInfo: {
              isModal: true
            },
          })
        )
      }
    }
  }, [location?.pathname]);

  const fetchShowDetails = async () => {
    try {
      const response = await getShowsByCategory(appInfo);

      if (response?.status === 200) {
        setFeatured(response?.data?.data?.find(item => item.type === "FEATURED"))
        dispatch(
          getHomeData({
            homeData: response?.data?.data
          })
        )
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
  };

  const bottomOfPageRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {

      if (
        bottomOfPageRef.current?.getBoundingClientRect().top <=
        window.innerHeight
      ) {
        console.log("User has reached the end of the window!");
        // You can trigger any actions you need here
      }
    };


    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const lazyLoad = () => {
    const containerHeight = homePageContainerRef?.current?.clientHeight;

    if (scrollPosition + 2500 >= containerHeight) {
      setHomeDataSliceCount(homeDataSliceCount + 5)
    }
  }
  
  const scrollToCategory = (categoryKey) => {
    const categoryElement = categoryRefs.current[categoryKey];
    if (categoryElement) {
      const offset = 100;
      const elementPosition = categoryElement.getBoundingClientRect().top + window.pageYOffset - offset;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      window.scrollTo({
        top: Math.min(elementPosition, maxScroll),
        behavior: "smooth"
      });
    }
  };

  const handleCategoryClick = (categoryKey) => {
    const index = homeData.findIndex(item => item.key === categoryKey);
    if (index !== -1 && index >= homeDataSliceCount) {
      setHomeDataSliceCount(index + 1);
      setTimeout(() => {
        scrollToCategory(categoryKey);
      }, 100);
    } else {
      scrollToCategory(categoryKey);
    }
    setIsManualScrolling(true);
    setActiveCategory(categoryKey);
    setTimeout(() => {
      setIsManualScrolling(false);
    }, 1000);
  };
  
  useEffect(() => {
    if (!loading && homeData.length > 0) {
      let timeout = null;
      
      const updateActiveCategory = () => {
        if (isManualScrolling) return;
        
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          let currentActive = null;
          let closestDistance = Infinity;
          
          for (const [key, element] of Object.entries(categoryRefs.current)) {
            if (element) {
              const rect = element.getBoundingClientRect();
              const distance = Math.abs(rect.top);
              
              if (distance < closestDistance && rect.top <= 200) {
                closestDistance = distance;
                currentActive = key;
              }
            }
          }
          
          if (currentActive && currentActive !== activeCategory) {
            setActiveCategory(currentActive);
          }
        }, 100);
      };
      
      window.addEventListener('scroll', updateActiveCategory);
      
      setTimeout(updateActiveCategory, 500);
      
      return () => {
        window.removeEventListener('scroll', updateActiveCategory);
        clearTimeout(timeout);
      };
    }
  }, [loading, homeData, activeCategory, isManualScrolling]);

  if (loading) {
    return <MainLoading />;
  }

  const renderContentSection = (data, index) => {
    const categoryKey = data?.key || data?.type || `category-${index}`;
    
    const setRef = (element) => {
      if (element) {
        categoryRefs.current[categoryKey] = element;
        window.__plutoCategoryRefs = categoryRefs.current;
      }
    };
    
    if (data.type !== "FEATURED" && (data.type === "TOP_TRENDING" || 
        data.type === "CONTINUE_WATCHING" || 
        data.type === "FEATURED2" || 
        data.type === "TOP_FEATURED" || 
        data.type === "MAGAZINES" || 
        data.type !== "LIVE_GUIDE")) {
      return (
        <div 
          ref={setRef} 
          data-category-key={categoryKey}
          data-category={categoryKey}
          className="pluto-category-section"
        >
          <Categories data={data} index={index} />
        </div>
      );
    }
    return null;
  };

  return (
    <div className="pluto-homepage-container">
      <div className="pluto-featured-wrapper">
        {homeData?.find(item => item.type === "FEATURED") && 
          <PlutoFeatured 
            data={homeData.find(item => item.type === "FEATURED")} 
          />
        }
      </div>
      
      <div className="pluto-category-container">
        <PlutoLeftSidebar 
          categories={homeData.filter(item => item.type !== "FEATURED")} 
          activeCategory={activeCategory}
          onCategoryClick={handleCategoryClick}
        />
        
        <div className="pluto-categories-container" ref={homePageContainerRef}>
          {
            homeData
              ?.filter(item => item.type !== "FEATURED")
              ?.slice(0, homeDataSliceCount)
              ?.map((item, index) => {
                return (
                  <Fragment key={`ContentSection${index}`}>
                    {renderContentSection(item, index)}
                  </Fragment>
                )
              })
          }
          {/* <div style={{paddingBottom:"6rem"}}></div> */}
        </div>
      </div>
    </div>
  );
});

PlutoHomePage.displayName = "PlutoHomePage";
export default PlutoHomePage;
